/**
 * Animation tokens — shared durations and easings so every component
 * pulls from the same vocabulary instead of inventing its own numbers.
 *
 * Keep this list short. If a one-off needs something bespoke, prefer
 * passing it inline rather than adding a new token that's only used once.
 */

/** Durations in seconds (Motion expects seconds, GSAP expects seconds). */
export const duration = {
  xs: 0.18,
  sm: 0.28,
  md: 0.45,
  lg: 0.7,
  xl: 1.0,
} as const;

/**
 * Cubic-bezier easings. Motion accepts these as `[x1, y1, x2, y2]` tuples.
 * For GSAP, use `easeOutCubic` etc. as named strings — these tuples mirror
 * the same curves so the two libraries feel consistent on screen.
 */
export const easing = {
  /** Standard ease-out — most UI movement. */
  out: [0.22, 1, 0.36, 1] as const,
  /** Stronger overshoot-y ease-out for things that should feel "settled". */
  outExpo: [0.16, 1, 0.3, 1] as const,
  /** Quick snap in/out used for hover micro-interactions. */
  inOut: [0.65, 0, 0.35, 1] as const,
  /** Gentle spring-like curve for peel/flip motion. */
  outBack: [0.34, 1.56, 0.64, 1] as const,
} as const;

/** Default Motion spring used for mouse-driven micro-interactions. */
export const spring = {
  soft: { type: "spring" as const, stiffness: 180, damping: 22, mass: 0.6 },
  snappy: { type: "spring" as const, stiffness: 320, damping: 28, mass: 0.5 },
} as const;
